import { TextField, Typography, Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CartNotesProps {
  notes: string;
  onNotesChange: (notes: string) => void;
  maxLength?: number;
}

export const CartNotes = ({
  notes,
  onNotesChange,
  maxLength = 150,
}: CartNotesProps) => {
  const { t } = useTranslation();

  const handleNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= maxLength) {
      onNotesChange(e.target.value);
    }
  };

  return (
    <Card sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
        {t('cart.notes.title', 'Special Instructions')}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        placeholder={t(
          'cart.notes.placeholder',
          'Any special requests or dietary restrictions?'
        )}
        value={notes}
        onChange={handleNotesChange}
        inputProps={{ maxLength }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'divider',
            },
            '&:hover fieldset': {
              borderColor: 'primary.main',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
              borderWidth: '1px',
            },
          },
          '& .MuiOutlinedInput-input': {
            color: 'text.primary',
          },
        }}
      />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', textAlign: 'right', mt: 0.5 }}
      >
        {notes.length}/{maxLength} {t('cart.notes.characters', 'characters')}
      </Typography>
    </Card>
  );
};
